import { cn } from "@repo/ui/lib/utils"
import * as React from "react"

interface ImageDisplayProps extends React.HTMLAttributes<HTMLDivElement> {
  image: string
  alt?: string
}

const ImageDisplay = React.forwardRef<HTMLDivElement, ImageDisplayProps>(
  ({ className, image, alt, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "h-11 w-11 flex items-center justify-center rounded-lg border bg-card",
          className,
        )}
        {...props}
      >
        <img
          src={image}
          alt={alt || ""}
          className="max-h-7 max-w-7 object-contain"
        />
      </div>
    )
  },
)
ImageDisplay.displayName = "ImageDisplay"

export { ImageDisplay, type ImageDisplayProps }
